import { Button } from '@mui/material';
import React, {useRef, useState} from 'react'
import './contact.css'
import { collection, addDoc } from "firebase/firestore";
import {db} from '../firebase'
import emailjs from 'emailjs-com';
import { motion } from "framer-motion"


function Contact() {
// start page at the top when refreshed
  window.onbeforeunload = function () {
    window.scrollTo(0, 0);
  };

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [feedback, setFeedback] = useState("");

  const [emails, setEmails] = useState("")
  const [message, setMessage] = useState("")
  const [user, setUser] = useState("")


  const handleSubmit = async(e) => {
    console.log("submitting");  
    e.preventDefault();
    const docRef = await addDoc(collection(db, "feedback"), {
      email: email,
      feedback: feedback,
      name: name
    });
    console.log("Document written with ID: ", docRef.id);

    setEmail("");
    setFeedback("");
  };

  const templateId = "template_gayks19";
  const serviceId = "service_s2ns9bo";
  const userId = "jBCmCb2eQDUsz4MGn";


       const form = useRef();

  const handleContactSubmit = async(e) => {
    e.preventDefault();
    emailjs.sendForm(
      serviceId,
      templateId,
      form.current
      ,
      userId
    ).then((result) => {
      console.log(result.text);
      // show success message
      const successMessage = document.querySelector(".getintouch form p");
      successMessage.style.display = "block";
      setTimeout(() => {
        successMessage.style.display = 'none';
    }, 5000);
    // clear form
    setUser("");
    setEmails("");
    setMessage("");
    
    }
    ).catch((error) => {
      console.log(error.text);
    });
  }


    return (
      <div className="allcontact">
         <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 1 }}
    >
     <div className="contactcontent">
      <h1>Contact Us</h1>
     </div>
        
        <div className="hg">

        
        <div className="htfu">
<h1>How To Find Us</h1>
<p>
  if you have any questions, just fill in the contact form and we will answer you shortly, if you are living nearby, come visit Paragon Homes Solutions at one of our comfortable offices.
</p>
<h2> Our Headquarters</h2>
<p>Mwalimu International Hotel, Opposite Total Engines along Kisii Town-Keroka Road
Kisii Town.</p>
<p>Telephone: <span>+254 104141843</span></p>
<p>Email: <span> info@paragonhomessolutions.com</span></p>
        </div>

        <div className="getintouch">
          <h1>Get in touch</h1>

          <form ref={form} onSubmit={handleContactSubmit}>
            <div className="namemail">
            <input type="text" name="user" placeholder="Name"
            value={user}
              required
              onChange={(e)=> setUser(e.target.value)}
              />
            <input type="email" name='emails' placeholder="Email"
            value={emails}
             required 
             onChange={(e)=> setEmails(e.target.value)}
             />
            </div>
            <textarea name="message" placeholder='Enter message here' className="contacttext" cols="30" rows="6"
            value={message}
            onChange={(e)=> setMessage(e.target.value)}
            >

            </textarea>
            <Button variant="outlined" type='submit' >SEND</Button>

            <p
              style={{
                color: "green",
                fontSize: "15px",
                marginTop: "10px",
                marginBottom: "10px",
                display: "none",
              }}
            >
              <span>SENT:</span> We will respond to your email as soon as possible.
            </p>
          </form>
        </div>
</div>
<hr 
style={{
  color: 'black',
  backgroundColor: 'black',
  height: 1,
  width: '80%',
  marginTop: '50px',
  marginBottom: '50px',
}}
/>

        <div class="feedback-card">
          <div class="feedback-header">LEAVE FEEDBACK</div>
          <form class="feedback-body" onSubmit={handleSubmit}>
            <input
              type="text"
              class="feedback-body__name"
              placeholder="Name"
              value={name}
              required
              onChange={(e) => setName(e.target.value)}
            />
            <input
              type="email"
              class="feedback-body__email"
              placeholder="Email"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)} 
            />
            <textarea
              type="text"
              class="feedback-body__message"
              placeholder="Message"
              value={feedback}
              required
              onChange={(e) => setFeedback(e.target.value)}
            ></textarea>
            <button class="feedback-body__submit">SEND</button>
          </form>
        </div>
        </motion.div>
      </div>
    );
}

export default Contact